import NR_CIV_SD_F003_001 from "../../assets/documents/NR_CIV_SD_F003_001.pdf";
import BriefingSessionVideos from "../../assets/documents/Briefing Session Videos.mp4";

export const standardsCategoryRows = [
  {
    id: 1,
    name: "Briefing Session Q&A [Issue: N/A] Standards Tracker Variation Briefing Session Q&A",
    publicationDate: "20/06/2025",
    complianceDate: "30/07/2025",
    docDesc:
      "For briefing material explaining the standards tracker variation, processes and reporting updates.",
    category: "Addendums",
    slug: "addendums",
    documentType: "Briefing and Training Materials",
    issue: 3,
    level: 2,
    nextReviewDate: "20/7/2025",
    items: "",
    size: "2GB",
    subscribed: true,
    favorite: true,
    applicability: "What projects or roles this standard applies to",
    complianceImpact: "Does this affect legal/regulatory compliance?",
    summaryOfChanges: "Short note: 'Updated steel load values'",
    attachments: []
  },
  {
    id: 2,
    name: "NR/CIV/SD/F003/001 [ Issue: B] Form 003: SDC Review Package A",
    publicationDate: "01/12/2018",
    complianceDate: "01/12/2018",
    docDesc:
      "For briefing material explaining the standards tracker variation, processes and reporting updates.",
    category: "Building And Civils Engineering",
    slug: "buildings-and-civils-engineering",
    documentType: "PDF",
    issue: "N/A",
    level: "N/A",
    nextReviewDate: "N/A",
    items: "",
    size: "20MB",
    subscribed: true,
    favorite: false,
    applicability: "Engineers",
    complianceImpact: "N/A",
    summaryOfChanges: "N/A",
    attachments: [
      {
        id: "att-1",
        name: "NR_CIV_SD_F003_001.pdf",
        size: "2.4 MB",
        file: NR_CIV_SD_F003_001,
      },
      {
        id: "att-2",
        name: "Briefing Session Videos.mp4",
        size: "50 MB",
        file: BriefingSessionVideos,
      },
    ],
  },
];
